import Modal from 'apollo-react/components/Modal';
import React from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';

const ConfirmCancelDialog = ({ open, onClose, handleConfirmCancel, text }) => {
  const translateString = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{ zIndex: 3301 }}
      title={translateString('Application Migration')}
      variant="warning"
      buttonProps={[
        {
          label: translateString('No'),
          variant: 'secondary',
          onClick: onClose,
        },
        {
          label: translateString('Yes'),
          variant: 'primary',
          onClick: handleConfirmCancel,
        },
      ]}
    >
      <p>{translateString('Do you want to terminate the process?')}</p>

      <p>{translateString(text)}</p>
    </Modal>
  );
};

export default ConfirmCancelDialog;
